/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InternalApiAttachCaseTransactionsRequest
 */
export interface InternalApiAttachCaseTransactionsRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof InternalApiAttachCaseTransactionsRequest
     */
    externalIds: Array<string>;
}

/**
 * Check if a given object implements the InternalApiAttachCaseTransactionsRequest interface.
 */
export function instanceOfInternalApiAttachCaseTransactionsRequest(value: object): value is InternalApiAttachCaseTransactionsRequest {
    if (!('externalIds' in value) || value['externalIds'] === undefined) return false;
    return true;
}

export function InternalApiAttachCaseTransactionsRequestFromJSON(json: any): InternalApiAttachCaseTransactionsRequest {
    return InternalApiAttachCaseTransactionsRequestFromJSONTyped(json, false);
}

export function InternalApiAttachCaseTransactionsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiAttachCaseTransactionsRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'externalIds': json['externalIds'],
    };
}

export function InternalApiAttachCaseTransactionsRequestToJSON(json: any): InternalApiAttachCaseTransactionsRequest {
    return InternalApiAttachCaseTransactionsRequestToJSONTyped(json, false);
}

export function InternalApiAttachCaseTransactionsRequestToJSONTyped(value?: InternalApiAttachCaseTransactionsRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'externalIds': value['externalIds'],
    };
}

